import React from "react";

export interface InfoItemData {
  label: string;
  value: React.ReactNode;
  /** Render as "Not available" muted text instead of hiding the item entirely. */
  emphasize?: boolean;
}

export const InfoItem: React.FC<InfoItemData> = ({ label, value, emphasize }) => (
  <div>
    <label className="block text-xs font-medium text-gray-500">{label}</label>
    <p className={emphasize ? "text-sm font-semibold text-gray-900" : "text-sm text-gray-900"}>
      {value === null || value === undefined || value === "" ? (
        <span className="text-gray-400 italic">Not available</span>
      ) : (
        value
      )}
    </p>
  </div>
);

interface InfoGridProps {
  items: InfoItemData[];
  columns?: 2 | 3 | 4;
}

/** Compact label/value grid used across Sensor Details, Calibration and Overview tabs. */
export const InfoGrid: React.FC<InfoGridProps> = ({ items, columns = 4 }) => {
  const colsClass =
    columns === 2
      ? "grid-cols-1 sm:grid-cols-2"
      : columns === 3
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      : "grid-cols-2 lg:grid-cols-4";

  return <div className={`grid ${colsClass} gap-4`}>{items.map((item, index) => (
    <InfoItem key={index} {...item} />
  ))}</div>;
};
